/**
 * This module re-exports all the base units for backwards compability
 */
import { BaseUnits } from "uom";
export var Ampere = BaseUnits.Ampere;
export var Candela = BaseUnits.Candela;
export var Kelvin = BaseUnits.Kelvin;
export var Kilogram = BaseUnits.Kilogram;
export var Meter = BaseUnits.Meter;
export var Mole = BaseUnits.Mole;
export var Second = BaseUnits.Second;
//# sourceMappingURL=base-units.js.map